import { getInstituteLogoUrl, INSTITUTE_NAME } from "@/lib/branding";

interface InstituteLogoProps {
  className?: string;
  /** CSS height in px (width auto) */
  height?: number;
}

export function InstituteLogo({ className = "", height = 40 }: InstituteLogoProps) {
  return (
    <img
      src={getInstituteLogoUrl()}
      alt={INSTITUTE_NAME}
      className={`object-contain select-none max-w-[min(100%,12rem)] ${className}`}
      style={{ height, width: "auto" }}
      loading="lazy"
      decoding="async"
    />
  );
}
